import { createContext, useContext } from "react";
export const EdgeCallbacksContext = createContext(null);
/**
 * Returns the ref itself so the caller can read .current at event time (always fresh).
 * Returns null if no provider — the edge component should guard before calling.
 */ export function useEdgeCallbacksRef() {
    return useContext(EdgeCallbacksContext);
}
export const EdgeWaypointActionsContext = createContext(null);
export function useEdgeWaypointActions() {
    return useContext(EdgeWaypointActionsContext);
}

//# sourceMappingURL=edgeCallbacks.js.map